import { useThrottledHandler } from 'App';
import SearchArea from 'pages/webapp/search/search-area';
import { useContext, useEffect, useState } from 'react';
import { AiOutlineDoubleLeft, AiOutlineDoubleRight, AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

const FilterBar = (data: { updateSortType: (sortType: string) => void }) => {
  const navigate = useNavigate();
  const [searchAllCategory, toggleSearchAllCategory] = useState(false);
  const [sortType, toggleType] = useState('latest'); // latest, trend, hotest
  const [expandSortType, toggleExpandSortType] = useState(true); // 是否展开排序按钮

  useEffect(() => {
    data.updateSortType(sortType);
  }, [sortType]);

  // 滑动监听
  let scrollTop = 0;
  let topValue = 0;
  const getScollTop = () => {
    let scrollTop = 0;
    if (document?.documentElement && document?.documentElement?.scrollTop) {
      scrollTop = document?.documentElement.scrollTop;
    } else if (document?.body) {
      scrollTop = document?.body.scrollTop;
    }
    return scrollTop;
  };
  const bindHandleScroll = () => {
    scrollTop = getScollTop();
    if (scrollTop <= topValue) {
      setTimeout(() => {
        toggleExpandSortType(true);
      }, 200);
    } else {
      setTimeout(() => {
        toggleExpandSortType(false);
      }, 500);
    }
    setTimeout(function () {
      topValue = scrollTop;
    }, 500);
  };
  useEffect(() => {
    window.addEventListener('scroll', bindHandleScroll);
    return () => {
      window.removeEventListener('scroll', bindHandleScroll);
    };
  }, []);

  return (
    <>
      {/* 搜索 + 排序 */}
      <div className=" flex justify-between items-center bg-slate-50 ">
        {/* 搜索区域 */}
        <div className=" text-nowrap flex-nowrap grow">
          <SearchArea
            showSwitch={false}
            onHover={(onHover) => {
              toggleExpandSortType(!onHover);
            }}
          />
        </div>
        {/* 排序区域 */}
        <div className=" flex gap-1 p-2 justify-end items-center text-sm text-nowrap">
          {(expandSortType || sortType === 'latest') && (
            <>
              <div
                className={[' shadow-md rounded-md p-1', sortType === 'latest' && ' bg-slate-500 text-white'].join(' ')}
                onClick={() => {
                  toggleType('latest');
                }}
              >
                ✨最新
              </div>
            </>
          )}
          {(expandSortType || sortType === 'trend') && (
            <>
              <div
                className={[' shadow-md rounded-md p-1', sortType === 'trend' && ' bg-slate-500 text-white'].join(' ')}
                onClick={() => {
                  toggleType('trend');
                }}
              >
                ❤️流行
              </div>
            </>
          )}
          {(expandSortType || sortType === 'hotest') && (
            <>
              <div
                className={[' shadow-md rounded-md p-1', sortType === 'hotest' && ' bg-slate-500 text-white'].join(' ')}
                onClick={() => {
                  toggleType('hotest');
                }}
              >
                🔥热门
              </div>
            </>
          )}
          {/* 折叠按钮 */}
          <div
            className=" bg-orange-500/90 text-white/100 px-1 py-0.5 rounded-md shadow-md"
            onClick={useThrottledHandler(() => {
              setTimeout(() => {
                toggleExpandSortType(!expandSortType);
              }, 500);
            })}
          >
            {expandSortType ? <AiOutlineDoubleRight size={24} /> : <AiOutlineDoubleLeft size={24} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBar;
